import React from 'react';

// Work History Data
const workHistoryItems = [
  { 
    period: "2026 — Now",  
    role: "Software Engineering",
    companyName: "AllTrails", 
    link: "https://www.alltrails.com"
  },
  { 
    period: "2019 — Now",  
    role: "Engineering & Product",
    companyName: "Half Lemons", 
    link: "https://www.halflemons.com"
  },
  { 
    period: "2014 — 2019", 
    role: "Product Management",
    companyName: "Borderfree", 
    link: "https://www.borderfree.com",
    acquisition: "Acquired by Pitney Bowes"
  },
  { 
    period: "2011 — 2014", 
    role: "Product Management",
    companyName: "Ghostery", 
    link: "https://www.ghostery.com",
    acquisition: "Acquired by Crownpeak"
  },
  { 
    period: "2010 — 2011", 
    role: "Marketing",
    companyName: "The Economist", 
    link: "https://www.economist.com"
  }
];

// Work History Item Component
const WorkHistoryItem: React.FC<{ 
  period: string; 
  role: string;
  companyName: string; 
  link: string; 
  acquisition?: string 
}> = ({ period, role, companyName, link, acquisition }) => {
  return (
    <div className="flex flex-col sm:flex-row ml-4 mr-4 mb-6 sm:mb-12 sm:border-0 sm:shadow-none border border-gray-200 rounded-lg p-4 sm:p-0 shadow-sm mx-0 sm:mx-0">
      <div className="w-full sm:w-32 mb-2 sm:mb-0">
        <p className="text-gray-400 text-xs">{period}</p>
      </div>
      <div className="sm:ml-6 sm:-mt-1 flex-1">
        <span className="font-light text-sm">
          {role} at{' '}
          <a 
            href={link} 
            target="_blank" 
            rel="noopener noreferrer" 
            className="hover:underline"
          >
            {companyName}
          </a>
          <span className="text-black ml-1 font-light text-sm">↗</span>
        </span>
        {acquisition && (
          <p className="text-gray-500 text-sm mt-1">{acquisition}</p>
        )}
      </div>
    </div>
  );
};

// Work History Component
const WorkHistory: React.FC = () => {
  return (
    <div className="flex flex-col">
      {workHistoryItems.map((item, index) => (
        <WorkHistoryItem 
          key={index} 
          period={item.period} 
          role={item.role}
          companyName={item.companyName} 
          link={item.link} 
          acquisition={item.acquisition} 
        />
      ))}
    </div>
  );
};

export default WorkHistory; 